import { useContext, useEffect, useState, useRef } from 'react';
import Tabs from '../../../Common/ui-components/Tabs';
import Table from '../../../Common/ui-components/Table';
import { FootballContext } from '../../../Home/FootballPage';
import { useTranslation } from 'react-i18next';
import FGSTable from './../FGSTable';
import { useWindowSize } from '../../../Common/CommonHooks';
import './index.scss';
import { getNumberSuffix } from '../MatchBase';
import {
    isMatchKickOff
} from '../MatchBase';

const GSTabTable =({foPool = [],getOddsVal, language,getTeamVal, match, gsTab,setGsTab})=>{
    const { isMobileSize } = useWindowSize();
    const context = useContext(FootballContext);
    const { t, i18n } = useTranslation();
    const PlayerBetTypeFilteringTab = window.fbConfig?.PlayerBetTypeFilteringTab
    const [isShowRed, setIsShowRed] = useState(false)
    let list = [{...PlayerBetTypeFilteringTab[0],id:'GSTabTable_GS'}]
    const messgeSuffix = context.state.windowSize.isMobileSize ? ' - Mobile' : ' - Desktop';
    const DefaultDisplayumber = 3;
    const tableRef = useRef(null);
    let isKickOff = isMatchKickOff(match.status);
    foPool.sort((a,b)=>{
        return PlayerBetTypeFilteringTab.findIndex(i=>a.oddsType == i.key) - PlayerBetTypeFilteringTab.findIndex(i=>b.oddsType == i.key)
    })
    let anyPoolSuspend = isKickOff && foPool.some(item => item.status != 'SELLINGSTARTED')
    let foPoolData = {}
    let columns = [
        {
          title:<div className='gstable_header'>
            <div>{t('LB_FB_GSTABLE_GS')}</div>
            {anyPoolSuspend && <div className='gstable_header_suspend'></div>}
          </div>,
          onCell: (param)=>{
            const selection= param.selections[0]
            const abbr = ['',t('LB_FB_H_S'), t('LB_FB_A_S')]
            const str = selection.str
            if (param.str === '000') {
                return  <div className="play_name" dangerouslySetInnerHTML={{ __html: t('LB_FB_GSTABLE_NONE') }}></div> 
            }
            return <div className='play_name'><span>({abbr[str[0]]}) {str} </span><span>{selection['name_'+language]}</span></div>
          }
        }
    ]
    foPool.map((i)=>{
        const oddsType = i.oddsType
        const index = PlayerBetTypeFilteringTab.findIndex(e=>e.key === oddsType)
        if (index !=-1) {
            let curItem = {...PlayerBetTypeFilteringTab[index], id: 'GSTabTable_'+PlayerBetTypeFilteringTab[index].key}
            if(i.instNo > 0){
                const instNo = i?.instNo;
                let ngoal = `${instNo}${i18n.language == 'en' ? getNumberSuffix(instNo) : ''}`;
                const instNoEn = ` [${t('LB_FB_N_GOAL',{lng: 'en'}).replace('{0}', ngoal)}]`
                const instNoCh = ` [${t('LB_FB_N_GOAL',{lng: 'ch'}).replace('{0}', ngoal)}]`
                curItem.en += instNoEn
                curItem.ch += instNoCh
            }
            list.push(curItem)
        }
        foPoolData[oddsType] = i
        const instNo = i.instNo
        
        let isStartSell = i?.status==="SELLINGSTARTED";
        let showSuspended = isKickOff && !isStartSell
        let ngoal = `${instNo}${i18n.language == 'en' ? getNumberSuffix(instNo) : ''}`;
        columns.push({
            title: <div className='gstable_header'>
                    <div>{`${t('LB_FB_GSTABLE_'+oddsType)}${instNo > 0 ? ` [${t('LB_FB_N_GOAL').replace('{0}', ngoal)}]` : '' }`}</div>
                    {anyPoolSuspend && <div className='gstable_header_suspend'>{ showSuspended ? `- ${t('LB_FB_SUSPENDED')}` : ''}</div>}
                </div>,
            onCell:(param,{rowIndex}) =>{
                return CheckBoxCell(param, oddsType,foPoolData[oddsType],rowIndex)
            }
        })
    })
    
    const getSelections = (foPools=[]) =>{
        let foPool = foPools.find(pool => pool.oddsType == 'FGS') || foPools.find(pool => pool.oddsType == 'LGS' ) || foPools.find(pool => pool.oddsType == 'NGS')
        if(!foPool) return
        let selections = getPlayerCombs(foPools)
        let combinations = selections.filter(comb => {
            let fgsCmb = foPoolData['FGS']?.lines?.[0]?.combinations?.find(c => c.str == comb.str)
            let agsCmb = foPoolData['AGS']?.lines?.[0]?.combinations?.find(c => c.str == comb.str)
            let lgsCmb = foPoolData['LGS']?.lines?.[0]?.combinations?.find(c => c.str == comb.str)
            let ngsCmb = foPoolData['NGS']?.lines?.[0]?.combinations?.find(c => c.str == comb.str)
            return [fgsCmb,agsCmb,lgsCmb, ngsCmb].some(curComb => (curComb && !['UNAVAILABLE', 'REFUND', 'WIN', 'IRRATIONAL', "REFUNDBEFORESUSPEND"].some(i => curComb.status.includes(i))))
        })
        let sels = []
        if(!isKickOff){ // Pre-Event
            sels = combinations.sort((a,b) =>{
                if(a.str == '000') return 1
                if(b.str == '000') return -1
                if(a.oddsType != b.oddsType) return window.fbConfig.GSPools.indexOf(a.oddsType) - window.fbConfig.GSPools.indexOf(b.oddsType)
                if(a.currentOdds != b.currentOdds) return a.currentOdds - b.currentOdds
                return a.str - b.str
            })
        }else{ // INPLAY
            let statusMap = {
                UNAVAILABLE:1,
                AVAILABLE:1,
                IRRATIONAL:2,
                WIN:2,
                REFUNDBEFORESUSPEND:3,
                REFUND:3
            }
            sels = combinations.sort((a,b) =>{
                if(a.str == '000') return 1
                if(b.str == '000') return -1
                if(statusMap[a.status] != statusMap[b.status]){
                   return statusMap[a.status] - statusMap[b.status]
                }
                else if(a.oddsType != b.oddsType) return window.fbConfig.GSPools.indexOf(a.oddsType) - window.fbConfig.GSPools.indexOf(b.oddsType)
                else if( a.oddsType == 'NGS' &&  (statusMap[a.status] == 1) && (a.currentOdds != b.currentOdds)) return a.currentOdds - b.currentOdds
                return a.str - b.str
            })
        }
        return sels
    }
    const change = (item,index)=>{
        setGsTab(item.key)
    }
    const CheckBoxCell = (param,betType,data,rowIndex)=>{
        const dom = getOddsVal(data.lines?.[0], param.str, isMobileSize,null,null,null,betType,rowIndex)
        if (!isShowRed&&rowIndex >=DefaultDisplayumber &&  dom?.props?.children?.props?.children[1]?.props?.children?.props?.checked) {
            setIsShowRed(true)
        }
        return dom
    }
 
    let isMobile = context.state.windowSize.isMobileSize;
    let msgKey  = gsTab
    if(gsTab == 'GS'){
        if(isKickOff){
            msgKey = 'PLAINPLAY'
        }else{
            msgKey = 'PLAPREEVENT'
        }
    }
    if(msgKey == 'AGS' ){
        if(isKickOff){
            msgKey = 'AGSINPLAY'
        }else{
            msgKey = 'AGSPREEVENT'
        }
    }
    const messageObj = context.betTypeMessages?.find(x => x.enable.value==="1" && x.key===msgKey+messgeSuffix);
    const dataTable = getSelections(foPool)
    useEffect(()=>{
            setIsShowRed(false)
            if(!tableRef.current?.getShowStatus()){
                dataTable.slice(3).map(rowData=>{
                    foPool.map((i)=>{
                        const oddsType = i.oddsType
                        const dom = getOddsVal(foPoolData[oddsType].lines?.[0], rowData.str, isMobileSize,null,null,null,oddsType)
                        const check = dom?.props?.children?.props?.children[1]?.props?.children?.props?.checked
                        if (check){
                            setIsShowRed(true)
                        }
                    })
                })
            }
    },[context.content.oddsSelection])
    useEffect(()=>{
        if (foPool.findIndex(i=>i.oddsType===gsTab)===-1) {
            setGsTab('GS')
        }
    },[foPool])

    return <div className='GSTabTable'>
        <Tabs list={list} selected={gsTab} change={change} label={language} foPool={foPool}>
            { messageObj && messageObj.message.value!='' && <div className="crsRemarks" dangerouslySetInnerHTML={{ __html: messageObj.message.value }}></div> }
                        {gsTab === 'GS' && <Table className="GSTable" data={dataTable} columns={columns} DefaultDisplayumber={DefaultDisplayumber} id="GS" isShowRed={isShowRed} ref={tableRef}></Table>}
            {foPool.filter(i=>i.oddsType===gsTab).map(i=>{
                return <>
                 <div className={`team ` + i.oddsType.toUpperCase()}>
                    {getTeamVal(match, 'HOME', '', false, isMobile)}
                    {getTeamVal(match, 'AWAY', '', false, isMobile)}
                </div>
                <FGSTable key={i.oddsType} foPool={foPoolData[i.oddsType]} isMobile={isMobile} getOddsVal={getOddsVal} foPools={foPool} betType={i.oddsType}/>
                </>
            })}
        </Tabs>
    </div>
}
export default GSTabTable

const getPlayerCombs = (foPools) =>{
    let sels = {}
    let selArr = []
    foPools.filter(pool => window.fbConfig.GSPools.includes(pool.oddsType)).forEach(pool =>{
        pool.lines[0].combinations.forEach(comb =>{
            if(!sels[comb.str]){
                sels[comb.str] = comb.status
                selArr.push({...comb, oddsType: pool.oddsType})
            }
        })
    })
    return selArr
}